/**
 * For linear USDT-margined futures, PnL as % of margin is roughly
 * (price move %) × leverage. TP/SL fields are price moves from entry.
 */
export function approxMarginRoiFromPriceMovePercent(
  priceMovePercent: number,
  leverage: number
): number | null {
  if (
    !Number.isFinite(priceMovePercent) ||
    priceMovePercent <= 0 ||
    !Number.isFinite(leverage) ||
    leverage < 1
  ) {
    return null;
  }
  return priceMovePercent * leverage;
}

export function formatRoiPercentLabel(value: number): string {
  const rounded = Math.round(value * 10) / 10;
  if (Number.isInteger(rounded)) {
    return String(rounded);
  }
  return rounded.toFixed(1);
}

/** PnL in USDT ≈ margin × (ROI% / 100), where ROI% ≈ priceMove% × leverage. */
export function approxMarginPnlUsdt(
  marginUsdt: number,
  priceMovePercent: number,
  leverage: number
): number | null {
  if (!Number.isFinite(marginUsdt) || marginUsdt <= 0) {
    return null;
  }
  const roiPct = approxMarginRoiFromPriceMovePercent(
    priceMovePercent,
    leverage
  );
  if (roiPct == null) {
    return null;
  }
  return (marginUsdt * roiPct) / 100;
}

export function formatApproxUsdtAmount(value: number): string {
  const rounded = Math.round(value * 100) / 100;
  const abs = Math.abs(rounded);
  const body = abs >= 1_000_000 ? abs.toFixed(0) : abs.toFixed(2);
  return body;
}
